export const translations = {
  ua: {
    languageLabel: "Мова",
    languages: {
      ua: "UA",
      pl: "PL",
    },
    navigation: {
      home: "Головна",
      about: "Про нас",
    },
    header: {
      callUs: "Зателефонуйте нам",
      contactUs: "Зв'яжіться з нами",
    },
    footer: {
      privacyPolicy: "Політика приватності",
      cookiePolicy: "Політика cookies",
      cookieSettings: "Налаштування cookies",
    },
    home: {
      heroSubtitle: "Агенція нерухомості",
      heroButton: "НАДІСЛАТИ ЗАПИТ",
      aboutButton: "ПРО НАС",
      formTitle: "Анкета для підбору нерухомості",
      submitButton: "ВІДПРАВИТИ",
    },
    form: {
      alertError: "Помилка відправки форми",
      intro: "Новий Запит",
      labels: {
        type: "Тип*",
        name: "Імʼя та прізвище*",
        email: "Електронна пошта*",
        phone: "Номер телефону*",
        socialMedia: "Телеграм / Інстаграм (нік)*",
        citizenship: "Громадянство*",
        family: "Склад сімʼї (якщо є діти - вік)*",
        animals: "Тварини (вік та вага)*",
        dateMoveIn: "Бажана дата поселення*",
        city: "Місто*",
        roomsNumber: "Кількість кімнат*",
        budget: "Бюджет (з комунальними)*",
        meters: "Метраж*",
        parking: "Паркінг*",
        workInfo: "Дані про роботу*",
        wishes: "Окремі побажання*",
        heardAboutUs: "Звідки Ви про мене дізнались*",
      },
      options: {
        type: {
          buy: "Купівля",
          rent: "Оренда",
        },
        city: {
          wroclaw: "Вроцлав",
          warsaw: "Варшава",
        },
        roomsNumber: {
          studio: "Кавалерка",
          twoRoom: "Двокімнатна",
          threeRoom: "Трикімнатна",
          house: "Будинок",
          room: "Кімната в квартирі або будинку",
        },
        parking: {
          yes: "Так",
          no: "Ні",
        },
      },
      consent:
        "Відправляючи анкету, ви даєте згоду на обробку персональних даних та погоджуєтесь з політикою конфіденційності",
      messageLabels: {
        type: "Тип",
        name: "Імʼя та прізвище",
        email: "Електронна пошта",
        phone: "Номер телефону",
        socialMedia: "Телеграм / Інстаграм (нік)",
        citizenship: "Громадянство",
        family: "Склад сімʼї",
        animals: "Тварини",
        dateMoveIn: "Бажана дата поселення",
        city: "Місто",
        roomsNumber: "Кількість кімнат",
        budget: "Бюджет (з комунальними)",
        meters: "Метраж",
        parking: "Паркінг",
        workInfo: "Дані про роботу",
        wishes: "Окремі побажання",
        heardAboutUs: "Звідки дізнались",
      },
    },
    submitted: {
      thanks: "Дякуємо",
      success: "Форму успішно надіслано",
    },
    about: {
      pageTitle: "OSka Нерухомість - це ключ до нових можливостей",
      intro: [
        "OSKA Нерухомість, це сучасне агентство нерухомості у Вроцлаві, яке допомагає клієнтам безпечно купувати, продавати, здавати в оренду та управляти нерухомістю.",
        "Ми робимо ставку на індивідуальний підхід, прозору співпрацю та комплексний супровід на кожному етапі. Завдяки значному досвіду роботи з іноземцями, які переїхали до Польщі, та глибокому знанню місцевого ринку нерухомості допомагаємо клієнтам приймати впевнені рішення як для власного проживання, так і для інвестування.",
        "Ми створюємо рішення, що відповідають цілям наших клієнтів, адже переконані: кожна нерухомість відкриває нові можливості для життя, розвитку та інвестицій.",
      ],
      servicesTitle: "Наші послуги",
      profileTitle: "Олена Середінська",
      profileSubtitle:
        "експерт ринку нерухомості та власниця OSка Нерухомість.",
      profileText: [
        "Поєднуючи понад 15 років досвіду у фінансах, будівництві та нерухомості в Україні з багаторічною практикою на ринку нерухомості Польщі, я допомагаю клієнтам бачити не лише об’єкт, а його реальну цінність, потенціал і перспективи та приймати виважені рішення для життя, інвестицій і впевненого майбутнього.",
      ],
      companyTitle: "Реквізити компанії",
      companyDetails: [
        { label: "Ім’я та прізвище", value: "OLENA SEREDINSKA" },
        { label: "Номер телефону", value: "538-386-012" },
        {
          label: "Електронна пошта",
          value: [
            "Seredinskaolena@gmail.com",
            "seredinska@oska-nieruchomosci.pl",
          ],
        },
        { label: "Номер NIP", value: "8993036584" },
        { label: "Номер REGON", value: "542811919" },
        {
          label: "Назва фірми",
          value: "OSka Nieruchomości OLENA SEREDINSKA",
        },
        {
          label: "Адреса для кореспонденції",
          value:
            "woj. DOLNOŚLĄSKIE, pow. Wrocław, gm. Wrocław, miejsc. Wrocław, ul. Krzysztofa Komedy, nr 15, 52-234",
          mapEmbedSrc:
            "https://maps.google.com/maps?q=Krzysztofa%20Komedy%2015%2C%20Wroc%C5%82aw&z=17&output=embed",
          mapLink:
            "https://www.google.com/maps/search/?api=1&query=Krzysztofa%20Komedy%2015%2C%20Wroc%C5%82aw",
        },
        {
          label: "Страховий поліс",
          value: [
            "POLISA UBEZPIECZENIA ODPOWIEDZIALNOŚCI CYWILNEJ ZAWODOWEJ",
            "Numer polisy 1114369103",
            "od 16.11.2025 r. do 15.11.2026 r.",
          ],
        },
      ],
      services: [
        {
          title: "Купівля нерухомості",
          description:
            "Допомога у пошуку та безпечному придбанні квартири, будинку або інвестиційного об’єкта.",
        },
        {
          title: "Продаж нерухомості",
          description:
            "Комплексний супровід продажу, від оцінки вартості до завершення угоди.",
        },
        {
          title: "Оренда та управління",
          description:
            "Пошук орендарів, супровід оренди та професійне управління нерухомістю.",
        },
        {
          title: "Інвестиції в нерухомість",
          description:
            "Підбір об’єктів для інвестування та консультації щодо розвитку інвестиційного портфеля.",
        },
      ],
      contactTitle: "Зв’яжіться з нами",
      contactQuestion:
        "Плануєте купівлю, продаж або інвестицію в нерухомість?",
      contactText:
        "Зв’яжіться з нами та отримайте професійну консультацію, адаптовану до ваших потреб і цілей.",
      contactButton: "НАДІСЛАТИ ЗАПИТ",
    },
    legal: {
      administratorName: "OLENA SEREDINSKA",
      brandName: "OSka Nieruchomości OLENA SEREDINSKA",
      nip: "8993036584",
      regon: "542811919",
      email: "seredinskaolena@gmail.com",
      officeEmail: "seredinska@oska-nieruchomosci.pl",
      phone: "538-386-012",
      address:
        "woj. DOLNOŚLĄSKIE, pow. Wrocław, gm. Wrocław, miejsc. Wrocław, ul. Krzysztofa Komedy, nr 15, 52-234",
      privacyPolicy: {
        pageTitle: "Політика приватності",
        updatedAt: "Дата оновлення: 31 травня 2026",
        intro:
          "Ця політика описує, як обробляються персональні дані користувачів сайту OSka Nieruchomości OLENA SEREDINSKA у зв’язку з використанням сайту, контактної форми та інших засобів зв’язку.",
        sections: [
          {
            title: "1. Адміністратор персональних даних",
            paragraphs: [
              "Адміністратором персональних даних є OLENA SEREDINSKA, NIP 8993036584, REGON 542811919, яка веде діяльність під брендом OSka Nieruchomości OLENA SEREDINSKA.",
              "З адміністратором можна зв’язатися електронною поштою: seredinskaolena@gmail.com або seredinska@oska-nieruchomosci.pl, телефоном: 538-386-012, або поштою за адресою: woj. DOLNOŚLĄSKIE, pow. Wrocław, gm. Wrocław, miejsc. Wrocław, ul. Krzysztofa Komedy, nr 15, 52-234.",
            ],
          },
          {
            title: "2. Обсяг і цілі обробки даних",
            paragraphs: [
              "У зв’язку з використанням контактної форми можуть оброблятися, зокрема: ім’я та прізвище, адреса електронної пошти, номер телефону, нік у соцмережах, громадянство, дані про склад сім’ї, інформація про тварин, бажана дата поселення, місто, кількість кімнат, бюджет, метраж, потреба в паркінгу, дані про роботу, побажання та джерело, звідки ви дізналися про послуги.",
              "Дані обробляються для відповіді на запит, підготовки пропозиції щодо послуг, здійснення дій на запит особи до укладення договору, а також для ведення поточного контакту у справах, пов’язаних із посередництвом та обслуговуванням нерухомості.",
            ],
          },
          {
            title: "3. Правові підстави обробки",
            paragraphs: [
              "Дані, передані через форму або під час безпосереднього контакту, обробляються на підставі ст. 6 ч. 1 літ. b RODO, якщо це необхідно для вчинення дій на запит особи перед укладенням договору, а також на підставі ст. 6 ч. 1 літ. f RODO для ведення листування, захисту від претензій та забезпечення безпеки сайту.",
              "У випадках, коли користувач окремо надає згоду, дані можуть також оброблятися на підставі ст. 6 ч. 1 літ. a RODO. Згоду можна відкликати в будь-який момент без впливу на законність обробки, здійсненої до її відкликання.",
            ],
          },
          {
            title: "4. Обов’язковість подання даних",
            paragraphs: [
              "Надання даних у контактній формі є добровільним, однак відсутність даних, позначених як обов’язкові, унеможливлює надсилання форми та отримання відповіді на запит.",
            ],
          },
          {
            title: "5. Одержувачі даних",
            paragraphs: [
              "Дані можуть передаватися постачальникам ІТ-рішень, хостингу, електронної пошти та іншим субпідрядникам, які підтримують роботу сайту або ділової комунікації, якщо це необхідно для належного надання послуг.",
              "Запити з форми надсилаються через Telegram Bot API, тому зміст форми може бути переданий до інфраструктури Telegram. Це означає, що дані можуть оброблятися також суб’єктами, які діють від імені Telegram.",
              "Якщо користувач скористається інтегрованим переглядом карти Google Maps, Google може отримати технічні дані користувача та зберігати власні cookies або подібні технології.",
            ],
          },
          {
            title: "6. Передача даних за межі ЄЕЗ",
            paragraphs: [
              "У зв’язку з використанням інструментів Telegram та Google окремі дані можуть передаватися за межі Європейської економічної зони. У таких випадках передача відбувається з використанням механізмів, передбачених RODO, якщо вони застосовуються постачальником відповідної послуги.",
            ],
          },
          {
            title: "7. Строк зберігання даних",
            paragraphs: [
              "Дані зберігаються протягом часу, необхідного для обробки запиту та ведення подальшого контакту, а після цього протягом строку, потрібного для захисту від можливих претензій або виконання законодавчих обов’язків.",
            ],
          },
          {
            title: "8. Права користувача",
            paragraphs: [
              "Особа, дані якої обробляються, має право на доступ до даних, їх виправлення, видалення, обмеження обробки, перенесення даних, заперечення проти обробки, а також право бути поінформованою про автоматизоване прийняття рішень, якщо таке застосовується.",
              "Особа також має право подати скаргу до Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa, якщо вважає, що її дані обробляються з порушенням закону.",
            ],
          },
          {
            title: "9. Контакт через e-mail та телефон",
            paragraphs: [
              "У разі контакту електронною поштою або телефоном персональні дані обробляються в межах, необхідних для відповіді на повідомлення, подальшої ділової комунікації та архівування листування.",
            ],
          },
          {
            title: "10. Профілювання та автоматизовані рішення",
            paragraphs: [
              "На сайті не приймаються автоматизовані рішення, які викликають юридичні наслідки для користувача. Дані з форми не використовуються для автоматизованого профілювання в розумінні RODO.",
            ],
          },
        ],
      },
      cookiePolicy: {
        pageTitle: "Політика cookies",
        updatedAt: "Дата оновлення: 31 травня 2026",
        intro:
          "Ця політика пояснює, як сайт OSka Nieruchomości OLENA SEREDINSKA використовує cookies, localStorage та інші подібні технології.",
        sections: [
          {
            title: "1. Що таке cookies",
            paragraphs: [
              "Cookies — це невеликі текстові файли, які зберігаються на пристрої користувача та можуть використовуватися для забезпечення коректної роботи сайту, запам’ятовування налаштувань або аналітики.",
            ],
          },
          {
            title: "2. Які технології використовуються на сайті",
            paragraphs: [
              "Сайт не використовує власних аналітичних або рекламних cookies, які відстежують користувача для маркетингових цілей.",
              "Сайт зберігає вибрану користувачем мову в localStorage браузера під ключем language. Це не є cookie, але виконує схожу функцію запам’ятовування налаштувань.",
              "При використанні вбудованого перегляду Google Maps сторонній постачальник може встановлювати власні cookies або інші подібні технології відповідно до своїх правил.",
            ],
          },
          {
            title: "3. Цілі використання технологій",
            paragraphs: [
              "Технічні механізми використовуються для коректної роботи сторінки, збереження вибраної мовної версії, забезпечення безпечного з’єднання та завантаження вбудованих сторонніх елементів, якщо користувач з них користується.",
            ],
          },
          {
            title: "4. Керування налаштуваннями",
            paragraphs: [
              "Користувач може керувати cookies через налаштування браузера, зокрема видаляти їх, блокувати або обмежувати для окремих сайтів. Також можна очистити localStorage у налаштуваннях браузера.",
              "Обмеження використання технічних cookies або localStorage може вплинути на окремі функції сайту, наприклад на запам’ятовування мови або коректне відображення деяких інтегрованих елементів.",
            ],
          },
          {
            title: "5. Cookies сторонніх сервісів",
            paragraphs: [
              "Сторонні сервіси, доступні через сайт, зокрема Google Maps, діють на підставі власних політик приватності та cookies. Перед взаємодією з такими сервісами варто ознайомитися з їхніми правилами.",
            ],
          },
        ],
      },
      cookieBanner: {
        title: "Ми використовуємо cookies та подібні технології",
        text:
          "Сайт зберігає вибір мови в браузері та може завантажувати Google Maps лише після вашої згоди на зовнішній вміст.",
        accept: "Прийняти",
        reject: "Лише необхідне",
      },
      mapConsentNotice:
        "Попередній перегляд Google Maps доступний після згоди на cookies.",
    },
  },
  pl: {
    languageLabel: "Język",
    languages: {
      ua: "UA",
      pl: "PL",
    },
    navigation: {
      home: "Strona główna",
      about: "O nas",
    },
    header: {
      callUs: "Zadzwoń do nas",
      contactUs: "Skontaktuj się z nami",
    },
    footer: {
      privacyPolicy: "Polityka prywatności",
      cookiePolicy: "Polityka cookies",
      cookieSettings: "Ustawienia cookies",
    },
    home: {
      heroSubtitle: "Agencja nieruchomości",
      heroButton: "WYŚLIJ ZAPYTANIE",
      aboutButton: "O NAS",
      formTitle: "Ankieta doboru nieruchomości",
      submitButton: "WYŚLIJ",
    },
    form: {
      alertError: "Błąd podczas wysyłania formularza",
      intro: "Nowe zapytanie",
      labels: {
        type: "Typ*",
        name: "Imię i nazwisko*",
        email: "Adres e-mail*",
        phone: "Numer telefonu*",
        socialMedia: "Telegram / Instagram (nick)*",
        citizenship: "Obywatelstwo*",
        family: "Skład rodziny (jeśli są dzieci - wiek)*",
        animals: "Zwierzęta (wiek i waga)*",
        dateMoveIn: "Preferowana data wprowadzenia*",
        city: "Miasto*",
        roomsNumber: "Liczba pokoi*",
        budget: "Budżet (z mediami)*",
        meters: "Metraż*",
        parking: "Parking*",
        workInfo: "Informacje o pracy*",
        wishes: "Dodatkowe życzenia*",
        heardAboutUs: "Skąd się o mnie dowiedziałeś/aś*",
      },
      options: {
        type: {
          buy: "Kupno",
          rent: "Wynajem",
        },
        city: {
          wroclaw: "Wrocław",
          warsaw: "Warszawa",
        },
        roomsNumber: {
          studio: "Kawalerka",
          twoRoom: "Dwupokojowe",
          threeRoom: "Trzypokojowe",
          house: "Dom",
          room: "Pokój w mieszkaniu lub domu",
        },
        parking: {
          yes: "Tak",
          no: "Nie",
        },
      },
      consent:
        "Wysyłając formularz, wyrażasz zgodę na przetwarzanie danych osobowych i akceptujesz politykę prywatności",
      messageLabels: {
        type: "Typ",
        name: "Imię i nazwisko",
        email: "Adres e-mail",
        phone: "Numer telefonu",
        socialMedia: "Telegram / Instagram (nick)",
        citizenship: "Obywatelstwo",
        family: "Skład rodziny",
        animals: "Zwierzęta",
        dateMoveIn: "Preferowana data wprowadzenia",
        city: "Miasto",
        roomsNumber: "Liczba pokoi",
        budget: "Budżet (z mediami)",
        meters: "Metraż",
        parking: "Parking",
        workInfo: "Informacje o pracy",
        wishes: "Dodatkowe życzenia",
        heardAboutUs: "Skąd się dowiedziałeś/aś",
      },
    },
    submitted: {
      thanks: "Dziękujemy",
      success: "Formularz został wysłany pomyślnie",
    },
    about: {
      pageTitle: "OSka Nieruchomości - klucz do nowych możliwości",
      intro: [
        "OSKA Nieruchomości to nowoczesne biuro nieruchomości we Wrocławiu, które pomaga klientom bezpiecznie kupować, sprzedawać, wynajmować oraz zarządzać nieruchomościami.",
        "Stawiamy na indywidualne podejście, przejrzystą współpracę oraz kompleksowe wsparcie na każdym etapie. Dzięki bogatemu doświadczeniu we współpracy z klientami zagranicznymi oraz doskonałej znajomości lokalnego rynku nieruchomości pomagamy podejmować świadome decyzje zarówno w celach mieszkaniowych, jak i inwestycyjnych.",
        "Tworzymy rozwiązania dopasowane do potrzeb i celów naszych klientów, ponieważ wierzymy, że każda nieruchomość otwiera nowe możliwości — do życia, rozwoju i budowania przyszłości.",
      ],
      servicesTitle: "Nasze usługi",
      profileTitle: "Olena Seredinska",
      profileSubtitle:
        "ekspertka rynku nieruchomości i właścicielka OSka Nieruchomości.",
      profileText: [
        "Łącząc ponad 15 lat doświadczenia w finansach, budownictwie i branży nieruchomości na Ukrainie z kilkuletnią praktyką na polskim rynku nieruchomości, pomagam klientom dostrzegać nie tylko samą nieruchomość, ale także jej rzeczywistą wartość, potencjał i perspektywy oraz podejmować świadome decyzje dotyczące życia, inwestycji i bezpiecznej przyszłości.",
      ],
      companyTitle: "Dane firmy",
      companyDetails: [
        { label: "Imię i nazwisko", value: "OLENA SEREDINSKA" },
        { label: "Numer telefonu", value: "538-386-012" },
        {
          label: "Adres poczty elektronicznej",
          value: [
            "Seredinskaolena@gmail.com",
            "seredinska@oska-nieruchomosci.pl",
          ],
        },
        { label: "Numer NIP", value: "8993036584" },
        { label: "Numer REGON", value: "542811919" },
        {
          label: "Firma przedsiębiorcy",
          value: "OSka Nieruchomości OLENA SEREDINSKA",
        },
        {
          label: "Adres do doręczeń",
          value:
            "woj. DOLNOŚLĄSKIE, pow. Wrocław, gm. Wrocław, miejsc. Wrocław, ul. Krzysztofa Komedy, nr 15, 52-234",
          mapEmbedSrc:
            "https://maps.google.com/maps?q=Krzysztofa%20Komedy%2015%2C%20Wroc%C5%82aw&z=17&output=embed",
          mapLink:
            "https://www.google.com/maps/search/?api=1&query=Krzysztofa%20Komedy%2015%2C%20Wroc%C5%82aw",
        },
        {
          label: "Polisa ubezpieczeniowa",
          value: [
            "POLISA UBEZPIECZENIA ODPOWIEDZIALNOŚCI CYWILNEJ ZAWODOWEJ",
            "Numer polisy 1114369103",
            "od 16.11.2025 r. do 15.11.2026 r.",
          ],
        },
      ],
      services: [
        {
          title: "Zakup nieruchomości",
          description:
            "Pomoc w znalezieniu i bezpiecznym zakupie mieszkania, domu lub nieruchomości inwestycyjnej.",
        },
        {
          title: "Sprzedaż nieruchomości",
          description:
            "Kompleksowa obsługa sprzedaży, od wyceny nieruchomości po finalizację transakcji.",
        },
        {
          title: "Wynajem i zarządzanie nieruchomościami",
          description:
            "Poszukiwanie najemców, obsługa najmu oraz profesjonalne zarządzanie nieruchomościami.",
        },
        {
          title: "Inwestycje w nieruchomości",
          description:
            "Dobór nieruchomości inwestycyjnych oraz wsparcie w budowaniu i rozwijaniu portfela inwestycyjnego.",
        },
      ],
      contactTitle: "Skontaktuj się z nami",
      contactQuestion:
        "Planujesz zakup, sprzedaż lub inwestycję w nieruchomość?",
      contactText:
        "Skontaktuj się z nami i skorzystaj z profesjonalnego wsparcia dopasowanego do Twoich potrzeb i celów.",
      contactButton: "WYŚLIJ ZAPYTANIE",
    },
    legal: {
      administratorName: "OLENA SEREDINSKA",
      brandName: "OSka Nieruchomości OLENA SEREDINSKA",
      nip: "8993036584",
      regon: "542811919",
      email: "seredinskaolena@gmail.com",
      officeEmail: "seredinska@oska-nieruchomosci.pl",
      phone: "538-386-012",
      address:
        "woj. DOLNOŚLĄSKIE, pow. Wrocław, gm. Wrocław, miejsc. Wrocław, ul. Krzysztofa Komedy, nr 15, 52-234",
      privacyPolicy: {
        pageTitle: "Polityka prywatności",
        updatedAt: "Data aktualizacji: 31 maja 2026",
        intro:
          "Niniejsza polityka prywatności opisuje zasady przetwarzania danych osobowych użytkowników serwisu OSka Nieruchomości OLENA SEREDINSKA w związku z korzystaniem ze strony internetowej, formularza kontaktowego oraz innych kanałów komunikacji.",
        sections: [
          {
            title: "1. Administrator danych osobowych",
            paragraphs: [
              "Administratorem danych osobowych jest OLENA SEREDINSKA, NIP 8993036584, REGON 542811919, prowadząca działalność pod marką OSka Nieruchomości OLENA SEREDINSKA.",
              "Z administratorem można skontaktować się drogą elektroniczną pod adresem: seredinskaolena@gmail.com lub seredinska@oska-nieruchomosci.pl, telefonicznie: 538-386-012 albo listownie na adres: woj. DOLNOŚLĄSKIE, pow. Wrocław, gm. Wrocław, miejsc. Wrocław, ul. Krzysztofa Komedy, nr 15, 52-234.",
            ],
          },
          {
            title: "2. Zakres i cele przetwarzania danych",
            paragraphs: [
              "W związku z korzystaniem z formularza kontaktowego mogą być przetwarzane w szczególności: imię i nazwisko, adres e-mail, numer telefonu, nick w mediach społecznościowych, obywatelstwo, informacje o składzie rodziny, zwierzętach, preferowanej dacie wprowadzenia, mieście, liczbie pokoi, budżecie, metrażu, potrzebie parkingu, danych o pracy, dodatkowych oczekiwaniach oraz źródle pozyskania informacji o usługach.",
              "Dane są przetwarzane w celu odpowiedzi na zapytanie, przygotowania oferty usług, podjęcia działań na żądanie osoby przed zawarciem umowy oraz prowadzenia bieżącego kontaktu w sprawach związanych z pośrednictwem i obsługą nieruchomości.",
            ],
          },
          {
            title: "3. Podstawy prawne przetwarzania",
            paragraphs: [
              "Dane przekazane przez formularz lub w ramach bezpośredniego kontaktu przetwarzane są na podstawie art. 6 ust. 1 lit. b RODO, jeżeli jest to niezbędne do podjęcia działań na żądanie osoby przed zawarciem umowy, a także na podstawie art. 6 ust. 1 lit. f RODO w celu prowadzenia korespondencji, obrony przed roszczeniami oraz zapewnienia bezpieczeństwa serwisu.",
              "W przypadkach, w których użytkownik udziela odrębnej zgody, dane mogą być także przetwarzane na podstawie art. 6 ust. 1 lit. a RODO. Zgoda może zostać wycofana w dowolnym momencie bez wpływu na zgodność z prawem przetwarzania dokonanego przed jej cofnięciem.",
            ],
          },
          {
            title: "4. Dobrowolność podania danych",
            paragraphs: [
              "Podanie danych w formularzu kontaktowym jest dobrowolne, jednak brak danych oznaczonych jako wymagane uniemożliwia wysłanie formularza i uzyskanie odpowiedzi na zapytanie.",
            ],
          },
          {
            title: "5. Odbiorcy danych",
            paragraphs: [
              "Dane mogą być przekazywane dostawcom rozwiązań IT, hostingu, poczty elektronicznej oraz innym podwykonawcom wspierającym działanie strony lub komunikację biznesową, jeżeli jest to niezbędne do prawidłowego świadczenia usług.",
              "Zapytania z formularza są wysyłane przez Telegram Bot API, dlatego treść formularza może zostać przekazana do infrastruktury Telegram. Oznacza to, że dane mogą być przetwarzane także przez podmioty działające w imieniu Telegram.",
              "W przypadku skorzystania z osadzonego podglądu Google Maps, Google może otrzymywać dane techniczne użytkownika oraz zapisywać własne cookies lub podobne technologie.",
            ],
          },
          {
            title: "6. Przekazywanie danych poza EOG",
            paragraphs: [
              "W związku z korzystaniem z narzędzi Telegram oraz Google niektóre dane mogą być przekazywane poza Europejski Obszar Gospodarczy. W takich przypadkach przekazywanie następuje z wykorzystaniem mechanizmów przewidzianych przez RODO, o ile są one stosowane przez dostawcę danej usługi.",
            ],
          },
          {
            title: "7. Okres przechowywania danych",
            paragraphs: [
              "Dane są przechowywane przez okres niezbędny do obsługi zapytania i dalszego kontaktu, a następnie przez czas potrzebny do obrony przed ewentualnymi roszczeniami lub wykonania obowiązków wynikających z przepisów prawa.",
            ],
          },
          {
            title: "8. Prawa osoby, której dane dotyczą",
            paragraphs: [
              "Osobie, której dane dotyczą, przysługuje prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia danych, wniesienia sprzeciwu, a także prawo do uzyskania informacji o zautomatyzowanym podejmowaniu decyzji, jeżeli miałoby ono zastosowanie.",
              "Osobie przysługuje również prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa, jeżeli uzna, że jej dane są przetwarzane niezgodnie z prawem.",
            ],
          },
          {
            title: "9. Kontakt przez e-mail i telefon",
            paragraphs: [
              "W przypadku kontaktu drogą elektroniczną lub telefoniczną dane osobowe są przetwarzane w zakresie niezbędnym do odpowiedzi na wiadomość, dalszej komunikacji biznesowej oraz archiwizacji korespondencji.",
            ],
          },
          {
            title: "10. Profilowanie i zautomatyzowane podejmowanie decyzji",
            paragraphs: [
              "W serwisie nie są podejmowane zautomatyzowane decyzje wywołujące skutki prawne wobec użytkownika. Dane z formularza nie są wykorzystywane do zautomatyzowanego profilowania w rozumieniu RODO.",
            ],
          },
        ],
      },
      cookiePolicy: {
        pageTitle: "Polityka cookies",
        updatedAt: "Data aktualizacji: 31 maja 2026",
        intro:
          "Niniejsza polityka wyjaśnia, w jaki sposób serwis OSka Nieruchomości OLENA SEREDINSKA korzysta z plików cookies, localStorage oraz podobnych technologii.",
        sections: [
          {
            title: "1. Czym są pliki cookies",
            paragraphs: [
              "Cookies to niewielkie pliki tekstowe zapisywane na urządzeniu użytkownika, które mogą być wykorzystywane do zapewnienia prawidłowego działania strony, zapamiętywania ustawień lub prowadzenia analiz.",
            ],
          },
          {
            title: "2. Jakie technologie są używane w serwisie",
            paragraphs: [
              "Serwis nie wykorzystuje własnych analitycznych ani reklamowych cookies służących do śledzenia użytkownika w celach marketingowych.",
              "Serwis zapisuje wybrany przez użytkownika język w localStorage przeglądarki pod kluczem language. Nie jest to cookie, ale pełni podobną funkcję zapamiętywania ustawień.",
              "W przypadku korzystania z osadzonego podglądu Google Maps zewnętrzny dostawca może zapisywać własne cookies lub stosować podobne technologie zgodnie z własnymi zasadami.",
            ],
          },
          {
            title: "3. Cele korzystania z technologii",
            paragraphs: [
              "Mechanizmy techniczne są używane do prawidłowego działania strony, zapamiętywania wybranej wersji językowej, zapewnienia bezpiecznego połączenia oraz ładowania zewnętrznych elementów osadzonych, jeżeli użytkownik z nich korzysta.",
            ],
          },
          {
            title: "4. Zarządzanie ustawieniami",
            paragraphs: [
              "Użytkownik może zarządzać cookies z poziomu ustawień przeglądarki, w tym usuwać je, blokować lub ograniczać dla wybranych witryn. Możliwe jest także wyczyszczenie localStorage w ustawieniach przeglądarki.",
              "Ograniczenie stosowania technicznych cookies lub localStorage może wpłynąć na niektóre funkcje serwisu, np. zapamiętywanie języka lub poprawne wyświetlanie wybranych elementów zewnętrznych.",
            ],
          },
          {
            title: "5. Cookies podmiotów trzecich",
            paragraphs: [
              "Usługi zewnętrzne dostępne za pośrednictwem serwisu, w szczególności Google Maps, działają na podstawie własnych polityk prywatności i cookies. Przed skorzystaniem z tych usług warto zapoznać się z ich zasadami.",
            ],
          },
        ],
      },
      cookieBanner: {
        title: "Używamy cookies i podobnych technologii",
        text:
          "Serwis zapisuje wybór języka w przeglądarce i może ładować Google Maps dopiero po wyrażeniu zgody na treści zewnętrzne.",
        accept: "Akceptuję",
        reject: "Tylko niezbędne",
      },
      mapConsentNotice:
        "Podgląd Google Maps jest dostępny po wyrażeniu zgody na cookies.",
    },
  },
};
